import { render, staticRenderFns } from "./ObjectsTable.vue?vue&type=template&id=7f980bfa&scoped=true"
import script from "./ObjectsTable.vue?vue&type=script&lang=ts"
export * from "./ObjectsTable.vue?vue&type=script&lang=ts"
import style0 from "./ObjectsTable.vue?vue&type=style&index=0&id=7f980bfa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f980bfa",
  null
  
)

export default component.exports